import * as React from 'react';

import CardWarranty from '../card-warranty/card-warranty';
import CardHistory from '../card-history/card-history';
import { Box, Typography, useMediaQuery } from '@mui/material';
import constants from '../../config/constants';
import HistoryIcon from '../../assets/icon/history-icon';
import WarrantyIcon from '../../assets/icon/warranty-icon';
import { useSelector } from 'react-redux';
import { getModelId, getUserId } from '../../store/car-slice';
import { handleGetLBlobsGcs } from '../../services/gcs';
import theme from '../../config/theme';
import FabControlled from '../../components/fab/fab-controlled';
import { urlParam } from '../../utils/url-param';

export default function FloatButtons() {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const isLandscape = useMediaQuery('(orientation: landscape)');

  // State
  const [openHistory, setOpenHistory] = React.useState(false);
  const [openWarranty, setOpenWarranty] = React.useState(false);
  const [carHistoryImages, setCarHistoryImages] = React.useState<any>([]);

  // Selectors
  const userId = useSelector(getUserId);
  const modelId = useSelector(getModelId);

  const storageRef = `users/${userId}/models/${modelId}/car-history`;

  const getCarHistory = async () => {
    const images = await handleGetLBlobsGcs(storageRef);

    setCarHistoryImages(images);
  };

  React.useEffect(() => {
    getCarHistory();
  }, []);

  const handleWarranty = (status: boolean) => setOpenWarranty(status);
  const handleHistory = (status: boolean) => setOpenHistory(status);

  // disable if viewPage is admin

  const viewPage = urlParam('viewPage');

  if (viewPage === 'admin') {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          zIndex: 1,
          background: constants.BLUR_STYLE.background,
          backdropFilter: constants.BLUR_STYLE.filter,
          borderRadius: '15px',
          position: 'fixed',
          top: isMobile ? 'unset' : '50%',
          right:
            !isMobile || (isMobile && isLandscape) || (isMobile && isLandscape)
              ? '1.1rem'
              : 'unset',
          left: isMobile && isPortrait ? 0 : 'unset',
          bottom:
            isMobile && isPortrait
              ? '3rem'
              : isMobile && isLandscape
                ? '5rem'
                : 'unset',
          transform: isMobile ? 'initial' : 'translate(0%, -50%)',
          padding: isMobile ? '0.5rem' : '2rem 1.5rem',
        }}
      >
        {carHistoryImages.length !== 0 && (
          <Box
            onClick={() => handleHistory(true)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 0.5,
              marginBottom: 4,
              [theme.breakpoints.down('lg')]: {
                marginBottom: 2,
              },
              cursor: 'pointer',
            }}
          >
            <FabControlled
              background={'rgba(255, 255, 255, 0.15)'}
              Icon={HistoryIcon}
              iconSizeDesktop="1.5rem"
            />
            <Typography
              sx={{ color: 'white', fontSize: isMobile ? 10 : 'initial' }}
            >
              History
            </Typography>
          </Box>
        )}
        <Box
          onClick={() => handleWarranty(true)}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            paddingBottom: 1,
            gap: 0.5,
            cursor: 'pointer',
          }}
        >
          <FabControlled
            background={'rgba(255, 255, 255, 0.15)'}
            Icon={WarrantyIcon}
            iconSizeDesktop="1.5rem"
          />
          <Typography
            sx={{ color: 'white', fontSize: isMobile ? 10 : 'initial' }}
          >
            Warranty
          </Typography>
        </Box>
      </Box>

      <CardWarranty
        onClose={() => handleWarranty(false)}
        open={Boolean(openWarranty)}
      />
      <CardHistory
        carHistoryImages={carHistoryImages}
        onClose={() => handleHistory(false)}
        open={Boolean(openHistory)}
      />
    </>
  );
}
